import { take, fork } from 'redux-saga/effects';
import { request } from 'utils/action';
import * as apis from 'common/apis';
import * as actions from 'actions/practice';

// 获取练习
export const watchGetPractice = function* watchGetPractice() {
  for (;;) {
    const { payload } = yield take(actions.getPractice);
    let newApis;
    if (payload.payload.id) {
      newApis = apis.getPractice.map((item, index) => {
        if (index === 1) {
          return `${item}/${payload.payload.id}`;
        }
        return item;
      });
    } else if (payload.payload.mode === 'test') {
      newApis = apis.getTest;
    } else {
      newApis = apis.getPracticeNew;
    }
    yield fork(
      request,
      actions.realGetPractice,
      newApis,
      payload,
    );
  }
};

// 创建练习
export const watchPostExercise = function* watchPostExercise() {
  for (;;) {
    const { payload } = yield take(actions.postExercise);
    yield fork(
      request,
      actions.realPostExercise,
      apis.postExercise,
      payload,
    );
  }
};




// WEBPACK FOOTER //
// ./src/sagas/practice.js